import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class QWebPrinterService {
  // Rutas.
  readonly URL_API = '/api/qapp/qwebprinter/';
  readonly URL_APISIGNER = '/api/qapp/qsigner/';
  private protocol = 'https://';

  constructor(private http: HttpClient) {}

  // GET: Obtener documentos.
  public getDocuments(url: string, document: any): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API + 'documents/', document);
  }

  // GET: Obtener banners.
  public getBanners(url: string, refOrder: any): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API + 'banners/', refOrder);
  }

  // POST: Obtener Customer.
  public postSigns(url: string, signs: any, token: string): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API + 'signs/', signs);
  }

  // GET: Obtener API
  public getApi(url: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'getApi');
  }

  // GET: Obtener servidor.
  public getServersByDmsCode(url: string, id: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_APISIGNER + 'bydmscode/' + id);
  }
}
